module.exports = __webpack_public_path__ + "908e4d2e/img/settings-ico.a214628d.svg";